export enum BuyerRevenuesActionTypes {
  SET_BUYER_REVENUES = 'SET_BUYER_REVENUES',
}

export interface Revenue {
  currency: string
  payerCompanyName: string
  disbursementDate: string
  labraBuyerId: string
  awsRevShare: string
  paymentDueDate: string
  agreementStartDate: string
  listingFeePercentage: string
  paymentTerms: string
  sellerNetRevenue: string
  grossAmount: string
  disbursementBillingEventId: string
  brokerId: string
  payerAwsAccountId: string
  buyerCountryCode: string
  agreementEndDate: string | null
  labraBuyerLogoUrl: string | null
  buyerAccountId: string
  privateOfferName: string
  buyerCompanyName: string | null
  billingAddressId: string
  disbursementStatus: string
  labraSubscriptionId: string
  productTitle: string
  payerAccountId: string
  listingFee: string
  transactionReferenceId: string
  payerStateOrRegion: string
  buyerPostalCode: string
  partnerId: string
  updateDate: string
  offerVisibility: string
  buyerCity: string
  payerEmailDomain: string
  productId: string
  labraProductId: string
  invoiceDate: string
  awsOfferId: string
  payerPostalCode: string
  insertDate: string
  sellerRevShare: string
  buyerEmailDomain: string
  agreementAcceptanceDate: string
  awsTaxShare: string
  buyerAddressId: string
  payerCountryCode: string
  buyerStateOrRegion: string
  grossRevenue: string
  agreementId: string
  invoiceId: string
  buyerAwsAccountId: string
  payerAddressId: string
  bankTraceId: string
  payerCity: string
  tcv: number
  totalReceived: number
  lastDisbursedReceivedDate: string | null
  lastDisbursedAmount: number | null
}

export interface Revenues {
  revenues: Revenue[]
}

export const initialBuyerRevenuesState: Revenues = { revenues: [] }

export type BuyerRevenuesAction = {
  type: BuyerRevenuesActionTypes.SET_BUYER_REVENUES
  payload: Revenues
}
